// Copyright (c) 2017 Deere & Company

import './audits-results-cell-renderer.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import {FormattedMessage} from 'react-intl';

function handleClick() {

    this.onClick(this.data.auditResults[0]);

}

/* eslint-disable react/prefer-stateless-function */

class AuditResultsCellRenderer extends Component {

    render() {

        return (
            <div className='audit-results-cell-renderer'>
                {this.props.data.auditResults.length > 0 &&
                    <span
                        className='audit-results-link'
                        onClick={this.props::handleClick}
                    >
                        <FormattedMessage id='AUDIT_RESULTS'/>
                    </span>
                }
            </div>
        );

    }

}

/* eslint-enable react/prefer-stateless-function */

AuditResultsCellRenderer.displayName = 'AuditResultsCellRenderer';
AuditResultsCellRenderer.propTypes = {
    data: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired
};

export default AuditResultsCellRenderer;



// WEBPACK FOOTER //
// ./src/reports/shared/report-cell-renderers/audit-results-cell-renderer.js